import React, { useEffect, useState } from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Link, Routes } from 'react-router-dom';
import TermsOfService from './TermsOfService';
import logo from './statsynclogo.png'; // Replace with your actual logo file path

function App() {
  const llcName = "Trideca Labs"; // Replace with your LLC name
  const description = "We are a lab that develops mobile apps focused in AI.";
  const comingSoon = "Coming Soon: ";
  const appName = "StatSync";
  
  const [displayedName, setDisplayedName] = useState('');
  const [displayedDesc, setDisplayedDesc] = useState('');
  const [displayedComingSoon, setDisplayedComingSoon] = useState('');
  const [displayedAppName, setDisplayedAppName] = useState('');
  const [nameDone, setNameDone] = useState(false);
  const [descDone, setDescDone] = useState(false);
  const [comingSoonDone, setComingSoonDone] = useState(false);

  // Type the LLC name
  useEffect(() => {
    let nameIndex = 0;

    const typeName = () => {
      if (nameIndex < llcName.length) {
        setDisplayedName(llcName.slice(0, nameIndex + 1));
        nameIndex++;
        setTimeout(typeName, 100); // Speed of typing for name
      } else {
        setNameDone(true);
      }
    };

    typeName();
  }, []);

  // Type the description
  useEffect(() => {
    if (nameDone) {
      let descIndex = 0;

      const typeDesc = () => {
        if (descIndex < description.length) {
          setDisplayedDesc(description.slice(0, descIndex + 1));
          descIndex++;
          setTimeout(typeDesc, 80); // Speed of typing for description
        } else {
          setDescDone(true);
        }
      };

      typeDesc();
    }
  }, [nameDone]);

  // Type the "Coming Soon" line and sequence logo + app name
  useEffect(() => {
    if (descDone) {
      let comingSoonIndex = 0;

      const typeComingSoon = () => {
        if (comingSoonIndex < comingSoon.length) {
          setDisplayedComingSoon(comingSoon.slice(0, comingSoonIndex + 1));
          comingSoonIndex++;
          setTimeout(typeComingSoon, 80); // Speed of typing for coming soon
        } else {
          setComingSoonDone(true);
        }
      };

      typeComingSoon();
    }
  }, [descDone]);

  // Type the app name after logo appears
  useEffect(() => {
    if (comingSoonDone) {
      let appNameIndex = 0;

      const typeAppName = () => {
        if (appNameIndex < appName.length) {
          setDisplayedAppName(appName.slice(0, appNameIndex + 1));
          appNameIndex++;
          setTimeout(typeAppName, 80); // Speed of typing for app name
        }
      };

      typeAppName();
    }
  }, [comingSoonDone]);

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route
            path="/"
            element={
              <div className="matrix-text">
                <h1>{displayedName}{nameDone ? '' : <span className="cursor">|</span>}</h1>
                {nameDone && (
                  <p className="description">{displayedDesc}{descDone ? '' : <span className="cursor">|</span>}</p>
                )}
                {descDone && (
                  <div className="coming-soon-container">
                    <p className="app-text">
                      {displayedComingSoon}
                      {comingSoonDone && (
                        <>
                          <img src={logo} alt="StatSync Logo" className="logo" />
                          <a href="https://statsync-app.com" target="_blank" rel="noopener noreferrer" className="app-link">
                            {displayedAppName}
                          </a>
                        </>
                      )}
                    </p>
                    <span className="cursor">|</span>
                  </div>
                )}
                <Link to="/terms" className="terms-link">Terms of Service</Link>
              </div>
            }
          />
          <Route path="/terms" element={<TermsOfService />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;